import { render, staticRenderFns } from "./MTourHeader.vue?vue&type=template&id=5820e604"
import script from "./MTourHeader.vue?vue&type=script&lang=js"
export * from "./MTourHeader.vue?vue&type=script&lang=js"
import style0 from "./MTourHeader.vue?vue&type=style&index=0&id=5820e604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports